import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { urlServicesPatientAdmin } from "../../constants/patients-admin.constants";
import { ResponseDto } from "../../models/generic/response.dto";
import { RestService } from "../communication-rest/communication-rest.service";
import { SexDto } from "../../models/catalog/sex.dto";
import { NationalitiesDto } from "../../models/catalog/nationalities.dto";
import { BiologicalSexDto } from "../../models/catalog/biological-sex.dto";
import { GenderPatientDto } from "../../models/catalog/gender.patient.dto";
import { IndigenousLanguagesDto } from "../../models/catalog/indigenous-languages.dto";
import { MaritalStatusDto } from "../../models/catalog/marital-status.dto";
import { MigrantDto } from "../../models/catalog/migrant.dto";
import { SchoolingDto } from "../../models/catalog/schooling.dto";
import { CatalogDto } from "../../models/generic/catalog.dto";
import { PatientOriginDto } from "../../models/catalog/patient-origin.dto";
import { PatientRequestStatusDto } from "../../models/catalog/patient-request-status.dto";

@Injectable({
    providedIn: 'root'
})
export class CatalogPatientService {
    
    urls = urlServicesPatientAdmin.catalogs;

    constructor(protected restService: RestService){
        
    }        
    //catalogs/sexes
    getSexes(): Observable<SexDto[]> {
        return this.restService.get<ResponseDto>(this.urls.sexes, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/nationalities
    getNationalities(): Observable<NationalitiesDto[]> {
        return this.restService.get<ResponseDto>(this.urls.nationalities, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/biological-sexes
    getBiologicalSexes(): Observable<BiologicalSexDto[]> {
        return this.restService.get<ResponseDto>(this.urls.biologicalSexes, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/genders
    getGenders(): Observable<GenderPatientDto[]> {
        return this.restService.get<ResponseDto>(this.urls.genders, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/indigenous-languages
    getIndigenousLanguage(): Observable<IndigenousLanguagesDto[]> {
        return this.restService.get<ResponseDto>(this.urls.indLanguages, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/marital-status
    getMaritalStatus(): Observable<MaritalStatusDto[]> {
        return this.restService.get<ResponseDto>(this.urls.marital, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/migrants
    getMigrants(): Observable<MigrantDto[]> {
        return this.restService.get<ResponseDto>(this.urls.migrants, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/schooling
    getSchoolings(): Observable<SchoolingDto[]> {
        return this.restService.get<ResponseDto>(this.urls.schooling, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/considered-indigenous
    getConsideredIndigenous(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.conIndigenous, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/speaks-indigenous-language
    getSpeaksIndigenousLanguages(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.conIndigenousLang, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/considered-afromexican
    getConsideredAfromexican(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.conAfromexican, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/born-here
    getBornsHere(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.bornHere, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/can-read-and-write
    getCanReadsWrites(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.readWrite, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/relationships
    getRelationships(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.relationships, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/affiliation-institutions
    getAffiliationInstitutions(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.affiliationInstitutions, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/type-affiliations
    getTypeAffiliations(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.typeAffiliations, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/gratuity
    getPerks(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.gratuity, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/insurers
    getInsurers(): Observable<CatalogDto[]> {
        return this.restService.get<ResponseDto>(this.urls.insurers, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
    //catalogs/patient-origin
    getPatientOrigins(birthDate?: Date): Observable<PatientOriginDto[]> {
        let url = this.urls.patientOrigin;
        
        // Solo agregar birthDate a la URL si se proporciona y es válida
        if (birthDate instanceof Date && !isNaN(birthDate.getTime())) {
            // Obtener solo la parte de la fecha (YYYY-MM-DD) del ISO string
            const formattedDate = birthDate.toISOString().split('T')[0];
            url = `${url}/${formattedDate}`;
        }
            
        return this.restService.get<ResponseDto>(url, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }

    //catalogs/request-status
    getRequestStatus(): Observable<PatientRequestStatusDto[]> {
        let url = this.urls.requestStatus;    
        return this.restService.get<ResponseDto>(url, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }
}